import Nav from 'scoreboard/components/nav'
import BookmarksGardener from './bookmarks-gardener'
import appDisplay from 'scoreboard/components/app-display'
import Bookmark from './bookmark'
import conductor from 'scoreboard/components/conductor'
import i18n from 'scoreboard/components/i18n'
import NoObject from 'scoreboard/components/no-object'
import permissions from 'scoreboard/components/permissions'
import HttpStatusCodes from 'http-status-codes'

var BookmarksNav = Nav.extend({

	section: 'bookmarks',
	Gardener: BookmarksGardener,

	Model: Bookmark,

	_bindEvents: function() {
		Nav.prototype._bindEvents.apply(this, arguments)
		if (!conductor.id()) {
			this.listenToOnce(this.gardener, 'node', function(n) {
				conductor.navigate(`/bookmarks/${n.id}`, { trigger: true, replace: true })
			}.bind(this))
		}
	},

	/**
	 * @inheritdoc
	 */
	onSelect: function(node) {
		node && conductor.changeId(node.id, { force: true })
	},

	isEditable: function() {
		return permissions.bookmarks()
	},

	gardenerError: function(stream) {
		if (stream.statusCode == HttpStatusCodes.NOT_FOUND) {
			// display the empty-tree view
			this.toggleTree(false)
			// show an appropriate message in the display pane
			var view = new NoObject({
				section: this.section,
				noTypeText: i18n.get('bookmarks.missing.1')
			})
			appDisplay.display(view)
		} else {
			this.$el.empty()
		}
	},

	_emptyTree: function() {
		Nav.prototype._emptyTree.apply(this, arguments)
		// show a custom message just for bookmarks
		this.$('.empty-tree-message').text(i18n.get('bookmarks.missing.1'))
		this.$('div.create').text(i18n.get('bookmarks.missing.2'))
		// remove the create text and button from the display
		this.$('button.create-first').toggleClass('is-not-displayed', true)
	},

	displayNoObjectView: function() {
		Nav.prototype.displayNoObjectView.apply(this, arguments)
		this.noObjectView.$('.empty-state-text')
			.text(i18n.get('bookmarks.missing.1'))
			.addClass('bookmark-empty-state-text')
	}

})

export default BookmarksNav

BookmarksNav.__filename__ = 'bookmarks/bookmarks-nav.js'
